import { SxProps, Theme } from '@mui/material';

export const pageContainer: SxProps<Theme> = {
  p: 4,
  minWidth: 0,
  maxWidth: '100%',
};

export const headerSection: SxProps<Theme> = {
  mb: 3,
};

export const pageTitle: SxProps<Theme> = {
  fontWeight: 600,
  mb: 0.5,
};
